"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateCatalogService = void 0;
var tslib_1 = require("tslib");
var catalog_service_1 = require("./catalog-service");
var PrivateCatalogService = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateCatalogService, _super);
    function PrivateCatalogService(httpClient, baseUrl) {
        return _super.call(this, httpClient, baseUrl, '/api/v2') || this;
    }
    return PrivateCatalogService;
}(catalog_service_1.CatalogServiceBase));
exports.PrivateCatalogService = PrivateCatalogService;
//# sourceMappingURL=private-catalog-service.js.map